import './styles/global.css';
import { App } from './App';
const root=document.querySelector<HTMLElement>('#app');if(!root)throw new Error('Missing #app root.');new App(root).start().catch(error=>{console.error(error);root.innerHTML='<main class="fatal"><h1>Dashboard failed to start</h1><p>Check the browser console for details.</p></main>';});
